import { service } from '@ember/service';
import Component from '@glimmer/component';
import type FastbootService from 'ember-cli-fastboot';

export interface FormationPartsTargetAudienceBadgeComponentArgs {}

export default class FormationPartsTargetAudienceBadgeComponent extends Component<FormationPartsTargetAudienceBadgeComponentArgs> {
  @service declare fastboot: FastbootService;
}
